import styled from '@emotion/styled';
import { Link } from 'gatsby';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';

const GroupedListStyled = styled.section`
    padding: 16px;
    background: ${({ theme }) => theme.colors.blue1};
    border-radius: 15px;
    margin-bottom: 24px;
    h2 {
        text-align: center;
        margin-bottom: 32px;

        text-transform: capitalize;
        color: ${({ theme }) => theme.colors.blue3};
    }
    @media ${({ theme }) => theme.device.tablet} {
        padding: 30px;
        margin-bottom: 40px;
    }
    @media ${({ theme }) => theme.device.laptop} {
        h2 {
            margin-bottom: 40px;
        }
    }
`;

const List = styled.ul`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .image {
        flex-shrink: 0;
        width: 90.5px;
        height: 88.5px;
        border-radius: 50%;
        border: 2px solid ${({ theme }) => theme.colors.blue3};
        margin-right: 24px;
        overflow: hidden;
        img {
            border-radius: 50%;
            transition: scale 0.2s ease-in-out;
            scale: 1;
        }
    }
    span {
        position: relative;
        bottom: 0px;
    }
    a {
        display: flex;
        flex-direction: row;

        align-items: center;
        padding: 8px 24px 8px 8px;
    }
    li {
        list-style: none;
        gap: 24px;
        width: 100%;
        margin-bottom: 24px;
        height: 107.03px;
        background-color: #fff0c8;
        border-radius: 100px;
        transition: background-color 0.2s ease-in-out;
        &:hover {
            background-color: #ffdf7e;
        }
        span {
            position: relative;
            left: 0px;
        }
        p {
            transform: translateY(-4px);

            font-weight: 600;
            font-size: 20px;
            line-height: 26px;
            max-width: 360px;
            color: ${({ theme }) => theme.colors.gray5};
        }
        a {
            color: ${({ theme }) => theme.colors.gray5};
        }
    }
    @media ${({ theme }) => theme.device.tablet} {
        .image {
            width: 87px;
            height: 87px;
            border-radius: 50%;
            border: 2px solid ${({ theme }) => theme.colors.blue3};
            margin-right: 24px;
            overflow: hidden;
        }
        li {
            gap: 24px;
        }
        a {
            &:hover {
                span {
                    position: relative;
                    left: 5px;
                }
                p {
                    color: ${({ theme }) => theme.colors.blue3};
                    transform: translate(5px, -4px);
                }

                .image {
                    img {
                        scale: 1.1;
                    }
                }
            }
        }
    }
    @media ${({ theme }) => theme.device.laptop} {
        li {
            gap: 24px;
            width: 476px;
            height: 107.03px;
            span,
            p {
                transition: color 0.2s ease-in-out;
            }
        }
    }
`;

export const GroupedList: React.FC<{
    type: string;
    category: string;
    title: string;
    allMdx: any;
}> = ({ allMdx, type, category, title }) => {
    let filteredMdx;
    let blockTitle;

    if (type === 'procedures') {
        blockTitle = category;
        filteredMdx = allMdx.edges.filter((mdx: any) => {
            if (
                mdx.node.frontmatter.category?.toLowerCase() === category.toLowerCase() &&
                mdx.node.frontmatter.title !== title &&
                !mdx.node.frontmatter.general
            ) {
                return mdx;
            }
        });
    } else {
        blockTitle = type;
        filteredMdx = allMdx.edges.filter((mdx: any) => {
            if (
                mdx.node.frontmatter.type === type &&
                mdx.node.frontmatter.title !== title &&
                !mdx.node.frontmatter.general
            ) {
                return mdx;
            }
        });
    }

    return (
        <GroupedListStyled>
            <h2>{blockTitle}</h2>
            <List>
                {filteredMdx.map(
                    ({
                        node: {
                            // ask smiley about this
                            frontmatter: { title, slug, featured_image },
                        },
                    }: {
                        node: {
                            frontmatter: {
                                title: string;
                                slug: string;
                                featured_image: {
                                    name: string;
                                    childImageSharp: { gatsbyImageData: IGatsbyImageData };
                                };
                            };
                        };
                    }) => (
                        <li key={title}>
                            <Link to={slug}>
                                <GatsbyImage
                                    className="image"
                                    image={featured_image.childImageSharp.gatsbyImageData}
                                    alt={featured_image.name}
                                />
                                <div>
                                    <p>{title}</p>
                                    <span>Explore more</span>
                                </div>
                            </Link>
                        </li>
                    )
                )}
            </List>
        </GroupedListStyled>
    );
};
